import { render, staticRenderFns } from "./ConfigurationReset.vue?vue&type=template&id=0c52cb76"
import script from "./ConfigurationReset.vue?vue&type=script&lang=js"
export * from "./ConfigurationReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports